import React from "react";
import { Layout, theme, Col, Row } from "antd";
import { useLocation } from "react-router-dom";
import MainSearch from "./MainSearch";
import MainAvatar from "./MainAvatar";
import MainHeaderClock from "./MainHeaderClock";

const { Header } = Layout;

const MainHeader = () => {
  const location = useLocation();
  const pathname = location.pathname;
  const {
    token: { colorBgContainer },
  } = theme.useToken();

  return (
    <Header
      style={{
        padding: 0,
        background: colorBgContainer,
        textAlign: "center",
      }}
    >
      <Row style={{ alignItems: "center" }}>
        <Col span={7}></Col>
        <Col span={10}>
          {pathname === "/" ||
          pathname === "/companyedit" ||
          pathname === "/departmentedit" ||
          pathname === "/positionedit" ||
          pathname === "/employeeedit" ||
          pathname === "/meetingroomedit" ||
          pathname === "/meetings" ||
          pathname === "/meetingoverview" ||
          pathname === "/meetingedit" ||
          pathname === "/addmeeting" ||
          pathname === "/admins" ||
          pathname === "/profile" ? (
            <MainHeaderClock />
          ) : (
            <MainSearch />
          )}
        </Col>
        <Col span={7}>
          <MainAvatar />
        </Col>
      </Row>
    </Header>
  );
};

export default MainHeader;
